import breakpoints from '../../scss/base/_breakpoints.module.scss';

/**
 * Handles the expansion/collapse of the state table on mobile/table viewports
 * Toggles the mobile-expanded class and animates the table visibility
 * @param {Event} e - The click event
 */
function handleTitleExpansion(e) {
  const $titleContainer = jQuery(e.currentTarget);
  $titleContainer.toggleClass('expanded');
  $titleContainer.siblings('.filter-state__table-container').slideToggle(300);
}

jQuery(($) => {
  /**
  * Updates the role attribute on the modules the title containers
  * On mobile/tablet viewports (<=tablet breakpoint), elements get role="button"
  * On desktop viewports, the role attribute is removed
  */
  function updateTitleRoles() {
    const $titles = $('div.filter-state__title');
    const isMobileOrTablet = jQuery(window).width() <= parseInt(breakpoints.tablet, 10);

    if (isMobileOrTablet) {
      $titles.attr('role', 'button');
    } else {
      $titles.removeAttr('role');
      // Clear the style on the table
      // so that if its display was set to 'none' from the jquery slide toggle,
      // it displays again on desktop
      $('.filter-state__table-container').attr('style', '');
    }
  }
  updateTitleRoles();
  $(window).on('resize', updateTitleRoles);
  $('body').on('click', 'div.filter-state__title[role="button"]', handleTitleExpansion);
});
